export default __webpack_public_path__ + "static/media/Vector_arleft.c67f63a2.svg";